export default "__VITE_ASSET__Bo_eaOS0__"